import type { CardTypeT } from '../../Card.h'

import { styled } from '@linaria/react'
import { IconSC, IconSizes } from 'atoms/Icon'
import { PosterSC } from 'atoms/ImagePoster'
import { Track } from 'atoms/ProgressBar'
import { Card, ImageBackgroundSC, PosterContainerSC } from 'blocks/Cards'
import { LockedPosterSC } from 'blocks/Cards/base-card'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const TitleComponentSC = styled.div`
  width: 100%;
  padding: var(${FIXED_INDENTS.INDENT_30});
`

export const VodSimpleCardSC = styled(Card)`
  ${PosterContainerSC} {
    ${TitleComponentSC} {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    ${ImageBackgroundSC} {
      ${PosterSC} {
        object-fit: cover;
      }

      ${LockedPosterSC} {
        ${IconSC} {
          font-size: ${IconSizes.xxmLarge};
        }
      }
    }
  }
`

export const CardContent = styled.div<{
  viewedButtonFavorite: boolean
  type?: CardTypeT
  padding?: FIXED_INDENTS
}>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 0.25rem;
  padding: ${({ padding }) =>
    padding ? `var(${padding})` : `var(${FIXED_INDENTS.INDENT_40})`};

  & > :nth-child(1) {
    margin: 0 0 auto auto;
    opacity: ${({ viewedButtonFavorite }) =>
      viewedButtonFavorite ? '1' : '0'};
    z-index: ${({ viewedButtonFavorite }) =>
      viewedButtonFavorite ? '5' : '-1'};
  }

  ${MEDIA.TOUCH} {
    display: none;
  }

  ${Track} {
    position: absolute;
    left: 0;
    bottom: 0;
  }
`
